import { V1LearningOrientation } from "src/pages/reports/fsci/v1/types";

export const meta: Record<V1LearningOrientation, Opportunity> = {
    collaboration: {
        title: "Collaboration",
        prologue: "Learning from and with other teachers drives and inspires better teaching.",
    },
    cultureOfImprovement: {
        title: "Culture of Improvement",
        prologue:
            "Guided by school leadership and focused on the future, the school is continually improving/makes necessary changes to improve.",
    },
    dataDrivenImprovement: {
        title: "Data-Driven Improvement",
        prologue:
            "Data is used to gauge school results and effectiveness, determine goal attainment, and address problems the school faces.",
    },
    feedback: {
        title: "Feedback",
        prologue:
            "Feedback on teaching practice and classroom management is given regularly to facilitate adjustments in real-time.",
    },
    individualizedInstruction: {
        title: "Individualized Instruction",
        prologue: "Students are helped to figure out how they learn best and to identify their natural strengths.",
    },
    outcomesFocus: {
        title: "Outcomes Focus",
        prologue:
            "A strong belief is held that process doesn’t matter if it isn’t producing results, and change is distracting if it doesn’t lead to increases in student achievement.",
    },
    professionalDevelopment: {
        title: "Professional Development",
        prologue: "PD is provided on-site and is subject- and role-specific.",
    },
    systemsThinking: {
        title: "Systems Thinking",
        prologue:
            "When planning for change, the potential impact on the school, the classroom, students, and the overall system are considered.",
    },
};
